var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OaoButton',{attrs:{"title":_vm.title,"type":"plain","buttonType":"button","fullwidth":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('p',{staticClass:"button-container"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('BaseIcon',{attrs:{"height":"3rem","width":"3rem","name":"Add","viewBox":"0 0 18 18"}},[_c('AddIcon')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }